export default __webpack_public_path__ + "static/media/T344_CoC.cfa14149.pdf";